import { useState, useRef, useContext } from "react";
import { Form, Button, Card, Modal } from "react-bootstrap";
import { Upload, Camera, Save, Trash, XCircle } from "react-bootstrap-icons";
import { InfraccionesContext } from "../context/InfraccionesContext";
import { guardarInfraccion } from "./guardarInfraccion";
import { uploadInfraccionPhoto } from "../services/api";
import "./mainpage.css";

export default function Fotografias({ setActivePage }) {
    const { form, resetForm } = useContext(InfraccionesContext);

    const [images, setImages] = useState({
        panoramica: null,
        placa: null,
        licencia: null,
        tarjeta: null,
    });

    const [showCameraModal, setShowCameraModal] = useState(false);
    const [currentImageType, setCurrentImageType] = useState(null);
    const [useFrontCamera, setUseFrontCamera] = useState(false);
    const cameraRef = useRef(null);
    const [cameraStream, setCameraStream] = useState(null);

    const handleImageChange = (e, type) => {
        const file = e.target.files[0];

        if (!file) return;

        if (!file.type.startsWith("image/")) {
            alert("Solo se permiten archivos de imagen (JPG, PNG, etc.).");
            e.target.value = "";
            return;
        }

        if (file.size > 10 * 1024 * 1024) {
            alert("El archivo excede los 10MB.");
            e.target.value = "";
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setImages(prev => ({ ...prev, [type]: file }));
        };
        reader.readAsDataURL(file);
    };


    const handleClear = () => {
        setImages({ panoramica: null, placa: null, licencia: null, tarjeta: null });
    };

    const handleCancel = () => {
        if (window.confirm("¿Estás seguro de que deseas cancelar y perder los cambios?")) {
            handleClear();
            resetForm();
            setActivePage("infracciones");
        }
    };

    const handleCameraClick = (type) => {
        setCurrentImageType(type);
        setShowCameraModal(true);
        startCamera();
    };

    const handleCloseCameraModal = () => {
        setShowCameraModal(false);
        stopCamera();
    };

    const handleTakePhoto = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const video = cameraRef.current;

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageDataUrl = canvas.toDataURL("image/png");
        const fileName = `${currentImageType}-${Date.now()}.png`;

        setImages(prev => ({ ...prev, [currentImageType]: dataURLtoFile(imageDataUrl, fileName) }));

        handleCloseCameraModal();
    };

    const startCamera = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: useFrontCamera ? "user" : "environment"
                }
            });
            setCameraStream(stream);
            if (cameraRef.current) {
                cameraRef.current.srcObject = stream;
            }
        } catch (err) {
            console.error("Error al iniciar cámara:", err);
        }
    };

    const stopCamera = () => {
        if (cameraStream) {
            cameraStream.getTracks().forEach(track => track.stop());
        }
    };

    const handleFinalizar = async () => {
        try {
            const urls = {};

            for (const tipo of Object.keys(images)) {
                const file = images[tipo];
                if (file) {
                    const publicUrl = await uploadInfraccionPhoto(file, tipo, "infracciones");
                    urls[tipo] = publicUrl;
                }
            }

            try {
                await guardarInfraccion(form, resetForm, handleClear, urls);
                alert("Infracción guardada correctamente.");
            } catch (error) {
                console.error("Error al guardar la infracción:", error);
                alert(`Error al guardar la infracción: ${error.message || error}`);
            }

        } catch (error) {
            console.error("Error en handleFinalizar:", error);
            alert("Ocurrió un error, intenta de nuevo.");
        }
    };


    const dataURLtoFile = (dataurl, filename) => {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    };

    return (
        <div className="container">
            <h1 className="title">Fotografías de la Infracción</h1>
            <p className="text-muted">Peso máximo por imagen: 10MB</p>
            <div className="divider"></div>

            <Form>
                <Card className="mb-4 p-4">
                    <div className="image-upload-container">
                        {[
                            { label: "Foto Panorámica *", name: "panoramica" },
                            { label: "Foto Placa *", name: "placa" },
                            { label: "Foto Licencia *", name: "licencia", visible: !form.conductorAusente && !form.sinLicencia },
                            { label: "Foto Tarjeta *", name: "tarjeta" }
                        ].filter(item => item.visible !== false).map((item, idx) => (
                            <div key={idx} className="image-upload">
                                <label className="form-label">{item.label}</label>
                                <div className="input-group">
                                    <span className="input-icon"><Upload /></span>
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => handleImageChange(e, item.name)}
                                    />
                                    <Button
                                        variant="secondary"
                                        onClick={() => handleCameraClick(item.name)}
                                        className="camera-button"
                                    >
                                        <Camera /> <span className="cam-text">Cámara</span>
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card>

                <div className="button-group">
                    <Button variant="primary" onClick={handleFinalizar}><Save /> Finalizar</Button>
                    <Button variant="secondary" onClick={handleClear}><Trash /> Limpiar</Button>
                    <Button variant="danger" onClick={handleCancel}><XCircle /> Cancelar</Button>
                </div>
            </Form>

            <Modal show={showCameraModal} onHide={handleCloseCameraModal} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Tomar Foto</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <video ref={cameraRef} autoPlay width="100%" height="auto" style={{ border: "1px solid #ccc" }}></video>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="warning" onClick={() => setUseFrontCamera(prev => !prev)}>
                        Cambiar Cámara
                    </Button>
                    <Button variant="secondary" onClick={handleCloseCameraModal}>Cancelar</Button>
                    <Button variant="primary" onClick={handleTakePhoto}>Tomar Foto</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
